// Wrapper function required because:
// handleFetchCheckoutSessionURL doesn't use any React context directly — it just calls getCheckoutSessionURL and returns the result.
// It could live at the module's top level as a plain exported function if its dependency (getCheckoutSessionURL) wasn't a hook.
// But getCheckoutSessionURL comes from useSubscriptionAPI(), which is a hook (calls useDashBaseAPI → useAuth0),
// and React's Rules of Hooks require hook calls to be inside a component or custom hook function — not at the module level.
// So the wrapper exists solely to give useSubscriptionAPI() a valid call site, which then makes getCheckoutSessionURL
// available in scope for handleFetchCheckoutSessionURL to reference.
import { useSubscriptionAPI } from "../useSubscriptionAPI.js"

export const useSubscription = () => {
    const { getSubscriptionsProxy, getPaymentMethodsProxy, getCheckoutSessionURL } = useSubscriptionAPI()

    const handleSubscriptionsProxy = async () => {
        const result = await getSubscriptionsProxy()    // can prob do better re: semantics in naming with fresh brain tomorrow
        return result.data
    }

    const handlePaymentMethodsProxy = async () => {
        const result = await getPaymentMethodsProxy()    // can prob do better re: semantics in naming with fresh brain tomorrow
        return result.data
    }

    const handleFetchCheckoutSessionURL = async () => {
        const result = await getCheckoutSessionURL()
        return result.data
    }

    return { 
        handleSubscriptionsProxy, 
        handlePaymentMethodsProxy,
        handleFetchCheckoutSessionURL
    }
}